import React from 'react';
import MediaRouteHeaderTitle from '@/components/Navigation/Routes/MediaRouteHeaderTitle';

const ImagesRouteNavigationOptions = {
  title: 'Images',
  headerTitle: () => (
    <MediaRouteHeaderTitle
      loggedInKey="navigation.images"
      loggedOutKey="navigation.createImages"
      fallback="Images"
    />
  ),
  headerBackVisible: false,
};

export default ImagesRouteNavigationOptions;
